import React, { useState } from "react";

const STEPS = [
  {
    icon: "🎮",
    title: "Bienvenue dans Checkpoint !",
    body: "Explore des donjons en vue isométrique, enchaîne les combats au tour par tour et descends le plus profond possible. Voici l'essentiel en 30 secondes.",
  },
  {
    icon: "🕹️",
    title: "Se déplacer",
    body: "Déplace ton héros avec ZQSD, WASD ou les flèches du clavier. Marche jusqu'au centre d'une salle pour déclencher son événement (combat, coffre, sanctuaire...).",
  },
  {
    icon: "🚪",
    title: "Les portes",
    body: "Une fois la salle terminée, des portes s'ouvrent dans les murs. Marche dans une porte pour passer à la salle suivante et progresser dans l'étage.",
  },
  {
    icon: "⚔️",
    title: "Le combat au tour par tour",
    body: "Utilise tes compétences pour attaquer. Chaque compétence coûte de l'énergie ⚡. Tu peux aussi te défendre pour réduire les dégâts et préparer un contre.",
  },
  {
    icon: "🌀",
    title: "Énergie, éléments & ennemis",
    body: "Chaque classe a sa réserve d'énergie. Les éléments se contrent entre eux (Feu, Eau, Terre, Air, Lumière...). Sous l'ennemi, ses compétences s'affichent : grisées = en récupération.",
  },
  {
    icon: "✨",
    title: "Les sanctuaires",
    body: "Les sanctuaires offrent un passif permanent pour toute la run (ex : Croissance, Cartographe, vol de vie...). Choisis bien : ils définissent ton style de jeu !",
  },
  {
    icon: "🛒",
    title: "Boutiques & coffres",
    body: "Dépense ton or 🪙 en boutique pour des potions permanentes et des coffres. Les coffres lâchent des objets, dont de puissantes reliques de scaling.",
  },
  {
    icon: "👑",
    title: "Objectif : le boss !",
    body: "Au bout de chaque étage t'attend un boss. Bats-le pour descendre à l'étage suivant, plus dangereux mais plus généreux. Bonne chance, aventurier !",
  },
];

export const TutorialOverlay = ({ onClose }) => {
  const [step, setStep] = useState(0);
  const isLast = step === STEPS.length - 1;
  const s = STEPS[step];

  return (
    <div
      data-testid="tutorial-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4"
    >
      <div className="relative w-full max-w-md bg-slate-900 border-4 border-slate-700 rounded-2xl p-6 cartoon-shadow-static animate-[fadeIn_0.2s_ease]">
        {/* Skip */}
        <button
          data-testid="tutorial-skip-btn"
          onClick={onClose}
          className="absolute top-3 right-4 text-xs font-bold uppercase tracking-wider text-slate-400 hover:text-slate-200 transition-colors"
        >
          Passer ✕
        </button>

        <div className="text-center mt-2">
          <div className="text-5xl mb-3">{s.icon}</div>
          <h2 className="font-display text-xl sm:text-2xl font-extrabold text-slate-50 mb-3">{s.title}</h2>
          <p className="text-sm text-slate-300 leading-relaxed min-h-[88px]">{s.body}</p>
        </div>

        {/* Progress dots */}
        <div className="flex items-center justify-center gap-1.5 my-4">
          {STEPS.map((_, i) => (
            <span
              key={i}
              className={`h-2 rounded-full transition-all ${i === step ? "w-6 bg-cyan-400" : "w-2 bg-slate-600"}`}
            />
          ))}
        </div>

        <div className="flex items-center justify-between gap-3">
          <button
            data-testid="tutorial-prev-btn"
            onClick={() => setStep((v) => Math.max(0, v - 1))}
            disabled={step === 0}
            className="px-4 py-2 rounded-xl font-bold text-sm bg-slate-800 text-slate-300 border-2 border-slate-700 disabled:opacity-30 hover:bg-slate-700 transition-colors"
          >
            Précédent
          </button>
          <span className="text-xs text-slate-500 font-bold">{step + 1} / {STEPS.length}</span>
          {isLast ? (
            <button
              data-testid="tutorial-done-btn"
              onClick={onClose}
              className="px-5 py-2 rounded-xl font-extrabold text-sm bg-emerald-500 text-slate-950 border-2 border-emerald-700 hover:bg-emerald-400 transition-colors cartoon-shadow-static"
            >
              C'est parti ! 🚀
            </button>
          ) : (
            <button
              data-testid="tutorial-next-btn"
              onClick={() => setStep((v) => Math.min(STEPS.length - 1, v + 1))}
              className="px-5 py-2 rounded-xl font-extrabold text-sm bg-cyan-500 text-slate-950 border-2 border-cyan-700 hover:bg-cyan-400 transition-colors cartoon-shadow-static"
            >
              Suivant →
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TutorialOverlay;
